import React from 'react';

import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const OpSenseToastContainer = () => (
  <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} draggable={false} transition={Slide} pauseOnFocusLoss pauseOnHover />
)

export default OpSenseToastContainer;